import { FC, useEffect } from "react";
import { SlCheck } from "react-icons/sl";

import { AddressCard, OrderDetailsCard } from "../../organisms";
import { getTimeAndDateStringFromEPOC } from "../../../utils";
import { analytics } from "../../analytics";
import { TransformedOrderDetailsEntity } from "../../../store/Services/OrderApi/Types";
import { useRouter } from "next/router";

let initialRender = true;

interface Props {
  order: TransformedOrderDetailsEntity;
}

export const CheckoutThankyou: FC<Props> = ({ order }) => {
  const { query } = useRouter();
  useEffect(() => {
    if (order && initialRender) {
      analytics.pushPurchase({ order, eventId: query.eventId });
      initialRender = false;
    }
  }, [order]);

  return (
    <div className="min-h-screen px-4 lg:px-6 2xl:px-60 space-y-8">
      <div className="flex gap-4 items-center">
        <SlCheck className="text-7xl sm:text-4xl text-green-600" />
        <div className="flex flex-col gap-1">
          <h1 className="pageTitle">Thank you</h1>
          <p className="text-sm text-gray-500">
            {order?.salesAgent
              ? "Our customer support executive has placed your order successfully. You will receive order confirmation email shortly"
              : "Your order has been placed successfully. You will receive order confirmation email shortly."}
          </p>
        </div>
      </div>
      <div>
        {order && (
          <div className="flex sm:grid flex-col-reverse sm:grid-cols-3 gap-12">
            <div className="sm:col-span-2 space-y-4">
              <p className="sectionTitle">Ordered Items</p>
              <div className="flex flex-col gap-8">
                {order.items.map(product => {
                  return (
                    <div key={product.id}>
                      <OrderDetailsCard
                        product={product}
                        currency={product.currencySymbol === "?" ? "₹" : "$"}
                      />
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="flex flex-col gap-8 sm:col-span-1">
              <div className="flex flex-col space-y-4 rounded-md">
                <p className="sectionTitle">Order details</p>
                <div className="grid gap-4">
                  <div className="space-y-1">
                    <p className="text-sm text-gray-500">Order Number</p>
                    <p className="text-sm">{order.orderNumber}</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-sm text-gray-500">Order placed on</p>
                    <p className="text-sm ">
                      {getTimeAndDateStringFromEPOC(order.createdAt).date}
                    </p>
                  </div>
                </div>
              </div>
              <div className="flex flex-col space-y-4 rounded-md">
                <p className="sectionTitle">Customer Information</p>
                <div className="grid gap-4">
                  <div className="space-y-1">
                    <p className="text-sm text-gray-500">Email</p>
                    <p className="text-sm ">{order.customer.email}</p>
                  </div>
                  <div className="space-y-1">
                    <p className="text-sm text-gray-500">Phone Number</p>
                    <p className="text-sm ">{order.customer.mobile}</p>
                  </div>
                </div>
              </div>
              <div className="space-y-4">
                <p className="sectionTitle">Shipping address</p>
                <AddressCard address={order.shippingAddress} />
              </div>
              <div className="space-y-4">
                <p className="sectionTitle">Billing address</p>
                <AddressCard address={order.billingAddress} />
              </div>

              {order.currency !== "$" ? (
                <div className="flex flex-col space-y-4 rounded-md">
                  <p className="sectionTitle">Order Update</p>
                  <p className="text-sm">
                    {order.orderType === "COD"
                      ? "Please keep exact change ready and pick calls from courier people."
                      : "Please pick calls from courier people."}
                  </p>
                </div>
              ) : null}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
